import React from 'react'
import '../styles/Navigation.css'
import Socails from './Socails'
export default function Navigation() {
  return (
    <div className='Navigation_container'id="navigation_container">
        <ol>
            <Socails/>
        </ol>
        <ul>
            <a href="#content">
                <li>
                    About
                </li>
                
            </a>
            <a href="#Roadmap_container">
                <li>
                    Roadmap
                </li>
            </a>
            <a href="#perks_container">
                <li>
                    Perks
                </li>
            </a>
            <a href="#themes_container">
                <li>
                    Themes
                </li>
            </a>
            <a id="shop_btn"href="https://opensea.io/Brewing_Banner_Project" style={{"border":'1px solid white',"marginRight":'10px','borderRadius':'10px'}}>
                <li>
                    Shop 
                </li>
            </a>
        </ul>
    </div>
  )
}
